"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const typePolicies_1 = __importDefault(require("@aurora/shared-apollo/typePolicies"));
const app_1 = require("@aurora/shared-types/app");
const query_hashes_json_1 = __importDefault(require("../generated/query-hashes.json"));
const resolvers_1 = __importDefault(require("./resolvers/resolvers"));
const config = {
    appId: app_1.AppType.END_USER,
    queryHashes: query_hashes_json_1.default,
    resolvers: resolvers_1.default,
    typePolicies: (0, typePolicies_1.default)(),
    defaultThemeId: 'aurora'
};
exports.default = config;
//# sourceMappingURL=appConfig.js.map